import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLogged: false,
    loggedUser: {
      name: "",
      email: "",
      token: "",
      level: 0,
      avatar: "",
    },
    showPageBar: true,
    pageTitle: "Vue App",
    vAlert: {
      show: false,
      text: ``,
      type: "info",
    },
  },
  mutations: {
    hideAlert(state) {
      state.vAlert.show = false;
    },

    hidePageBar(state) {
      state.showPageBar = false;
    },

    setAlert(state, payload) {
      if (payload === null) {
        state.vAlert.show = false;
      } else {
        state.vAlert = {
          show: true,
          text: payload.text,
          type: payload.type,
        };
      }
    },

    setPageTitle(state, payload) {
      state.pageTitle = payload;
      state.showPageBar = true;
    },

    showPageBar(state) {
      state.showPageBar = true;
    },

    updateLogged(state, payload) {
      if (payload === null) {
        state.isLogged = false;
        state.loggedUser = {
          name: "",
          email: "",
          token: "",
          level: 0,
          avatar: "",
        };
      } else {
        state.isLogged = true;
        state.loggedUser = {
          name: payload.name,
          email: payload.email,
          token: payload.token,
          level: payload.level,
          avatar: payload.avatar,
        };
      }
    },
  },
  actions: {},
  modules: {},
});
